import { DetailedIcon } from './DetailedIcon';

// TODO: in v9, move styled() from DetailedIcon.jsx to here
export var StyledDetailedIcon = DetailedIcon;